import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ParticleField from "./ParticleField";
import AnnouncementBar from "./AnnouncementBar";
import MobileNav from "./MobileNav";
import PushInit from "./PushInit";

export default function Layout() {
  const location = useLocation();
  const hideFooter = /^\/pluse(?:\/|$)/i.test(location.pathname) || /^\/hashtag(?:\/|$)/i.test(location.pathname) || /^\/Communities(?:\/|$)/i.test(location.pathname);

  return (
    <div className="relative min-h-screen bg-black text-white overflow-x-hidden">
      <ParticleField />
      <Navbar />
      <AnnouncementBar />
      <main className="relative z-10 pb-20 lg:pb-0">
        <Outlet />
      </main>
      {!hideFooter && <Footer />}
      <MobileNav />
      <PushInit />
    </div>
  );
}
